import { login } from '@/api/auth';
import { saveUserData, logout } from '@/utils/auth';

const state = {
  token: null,
  userName: null,
  email:null,
  id:null,
  account_type:null,
  crm_role:null,
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  getUserName: () => localStorage.getItem('user_name'),
  getUserEmail: () => localStorage.getItem('email'),
  getUserId: () => localStorage.getItem('id'),
  getUserType: () => localStorage.getItem('account_type'),
  getUserRole: () => localStorage.getItem('crm_role'),
};

const actions = {
  async login({ commit }, { email, password }) {
    try {
      const data = await login(email, password);
      if (data.token) {
        saveUserData(data.token , data.email , data.id , data.user_name , data.account_type , data.crm_role); // Save token to localStorage and cookies
        commit('SET_AUTH', { token: data.token, user_name: data.user_name , id:data.id , email:data.email , type:data.account_type});
      }else{
        throw new Error(data.error);
      }
      return data;
    } catch (error) {
      throw error;
    }
  },
  logout({ commit }) {
    logout();
    commit('CLEAR_AUTH');
  },
};

const mutations = {
  SET_AUTH(state, { token, user_name , email , id , type }) {
    state.token = token;
    state.userName = user_name;
    state.email = email;
    state.id = id;
    state.account_type = type;
  },
  CLEAR_AUTH(state) {
    state.token = null;
    state.userName = null;
    state.email = null;
    state.id = null;
    state.account_type = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
